<template>
  <div>
    <b-modal
      id="modal-job-posting-response"
      ref="modal_job_posting_response"
      :title="title"
      size="lg"
      modal-class="custom-modal"
      lazy
      centered
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      @hidden="onHidden"
    >
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-form>
            <b-card bg-variant="light">
              <b-row>
                <b-col cols="lg" class="mt-2 mb-2">
                  <b-skeleton width="13%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="mb-2">
                  <b-skeleton width="5%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="mb-2">
                  <b-skeleton width="16%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="mb-2">
                  <b-skeleton width="13%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="mb-2">
                  <b-skeleton width="6%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="mb-2">
                  <b-skeleton width="8%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="mb-2">
                  <b-skeleton width="6%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-skeleton width="13%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
            </b-card>
          </b-form>
        </template>

        <template #default>
          <b-form>
            <b-card class="custom-card">
              <b-form-group id="group-job-posting-select" label="Объявление">
                <recruit-job-posting-select
                  ref="job_posting_select"
                  :is-disabled="isDisabled"
                  :value="newItem.job_posting_id"
                  :state="getFieldState('job_posting_id')"
                  @onSelect="onJobPostingSelect"
                />
              </b-form-group>
              <b-form-group id="group-location" label="Объект">
                <b-form-input
                  type="text"
                  :value="newItem.location_name"
                  disabled
                />
              </b-form-group>
              <b-form-group id="group-name" label="ФИО">
                <b-form-input
                  type="text"
                  placeholder="Введите ФИО"
                  :disabled="isDisabled"
                  :state="getFieldState('name')"
                  v-model="newItem.name"
                />
              </b-form-group>
              <b-form-group id="group-birth-date" label="Дата рождения">
                <b-form-input
                  type="date"
                  :disabled="isDisabled"
                  v-model.date="newItem.birth_date"
                />
              </b-form-group>
              <b-form-group id="group-citizenship" label="Гражданство">
                <citizenship-select
                  id="input-citizenship-select"
                  :is-disabled="isDisabled"
                  :value="newItem.citizenship_id"
                  @onSelect="onSelectCitizenship"
                />
              </b-form-group>
              <b-form-group id="group-town" label="Город">
                <town-select
                  :value="newItem.town_id"
                  @onSelect="onSelectTown"
                  :is-disabled="isDisabled"
                />
              </b-form-group>
              <b-form-group id="group-phone" label="Контакт">
                <b-input-group size="sm" prepend="+7">
                  <b-form-input
                    type="text"
                    :disabled="isDisabled"
                    placeholder="Введите номер"
                    :state="phoneState"
                    v-model="newItem.phone"
                  />
                  <b-form-invalid-feedback :state="phoneState">
                    {{phoneInvalidFeedback}}
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
              <b-form-group id="group-email" label="Почта">
                <b-form-input
                  type="text"
                  :disabled="isDisabled"
                  placeholder="Введите почту"
                  v-model="newItem.email"
                />
              </b-form-group>
              <b-form-group id="group-status" label="Статус">
                <recruit-response-status-select
                  :is-disabled="isDisabled"
                  :state="getFieldState('status_id')"
                  :value="newItem.status_id"
                  @onSelect="onSelectRecruitResponseStatus"
                  drop-up
                />
              </b-form-group>
              <!-- TODO: нейминг сущности -->
              <b-form-group id="group-response-date" label="Дата отклика">
                <b-form-input
                  type="date"
                  :disabled="isDisabled"
                  v-model.date="newItem.start_date"
                />
              </b-form-group>
            </b-card>
          </b-form>
        </template>
      </b-skeleton-wrapper>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end py-2">
          <b-button :disabled="loading" :class="!newItem.fits ? 'custom-btn-primary' : 'custom-btn-danger'" class="mr-1" @click="toggleFit()">
            <font-awesome-icon :icon="!newItem.fits ? 'check' : 'times'" class="mr-1"/>
            {{ !newItem.fits ? 'Подходит' : 'Не подходит' }}
          </b-button>
          <b-button class="custom-btn-secondary ml-auto mr-2" @click="handleCancel">
            Отменить
          </b-button>
          <b-button class="custom-btn-primary" :disabled="loading" @click="handleOk">
            <b-spinner v-if="loading" small/>
            Сохранить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import recruitJobPostings from "../../network/recruitJobPostings";
  import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import permissions, {PERM} from "../../utilites/permissions";
    import RecruitJobPostingSelect from "./RecruitJobPostingSelect.vue";
    import CitizenshipSelect from "../Catalogs/Citizenships/CitizenshipSelect.vue";
    import TownSelect from "../Catalogs/Towns/TownSelect.vue";
    import RecruitResponseStatusSelect from "../Catalogs/RecruitResponseStatuses/RecruitResponseStatusSelect.vue";

export default {
  name: 'JobPostingResponse',
  components: { RecruitResponseStatusSelect, TownSelect, CitizenshipSelect, RecruitJobPostingSelect },
  mixins: [
    recruitJobPostings,
    catalogs,
    helpers, dateFormatter, permissions
  ],
  props: {},
  data() {
    return {
      title: 'Кандидат',
      newItem: this.setNewItem(),
      isDisabled: true,
      isBusy: false,
      loading: false,
    }
  },
  computed: {
    phoneState() {
      return /^\d{10}$/.test(this.newItem.phone);
    },
    phoneInvalidFeedback() {
      return 'Телефон должен состоять только из 10 цифр без пробелов и скобок.';
    },
  },
  methods: {
    setNewItem() {
      return {
        id: 0,
        job_posting_id: null,
        recruit_task_id: null,
        worker_id: null,
        worker_name: '',
        assigned: null,
        fits: null,
        name: '',
        phone: '',
        email: '',
        birth_date: null,
        citizenship_id: null,
        town_id: null,
        town_name: '',
        location_id: null,
        location_name: '',
        status_id: 1,
        status_name: '',
        comment: '',
        // TODO: нейминг start_date
        start_date: null,
        provider_id: null,
        provider_name: '',
      };
    },
    async showModal(responseId, isView) {
      this.isDisabled = isView;
      this.newItem = this.setNewItem();
      this.$refs.modal_job_posting_response.show();

      if (responseId) {
        await this.getResponse(responseId);
      }
    },
    hideModal() {
      this.$refs.modal_job_posting_response.hide();
    },
    handleOk() {
      this.handleSubmit();
    },
    handleCancel() {
      this.hideModal();
    },
    onHidden() {
      this.$emit('modal-closed');
    },
    async getResponse(responseId) {
      this.isBusy = true;
      this.loading = true;

      const result = await this.getResponseById(responseId);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = result.data;

      this.newItem.birth_date = this.formattedFromServerDate(this.newItem.birth_date);
      this.newItem.start_date = this.formattedFromServerDate(this.newItem.start_date);

      this.isBusy = false;
      this.loading = false;
    },
    async handleSubmit() {
      const submitValidation = [
        { item: 'job_posting_id', message: 'Выберите объявление.' },
        { item: 'phone', message: 'Укажите номер телефона.' },
        { item: 'name', message: 'Укажите ФИО.' },
        { item: 'status_id', message: 'Выберите статус отклика.' },
      ];

      for (let i = 0; i < submitValidation.length; i++) {
        const validation = submitValidation[i];

        if (validation.condition !== false && !this.newItem[validation.item]) {
          this.showSubmitError(validation.message);
          return;
        }
      }

      this.loading = true;
      const data = this.newItem;

      data.birth_date = this.formattedToServerDate(data.birth_date);
      data.start_date = this.formattedToServerDate(data.start_date);

      const method = (data.id > 0) ? this.putResponse : this.postResponse;
      const result = await method(data);

      if (!result.data) {
        this.showError("Не удалось сохранить данные.");
        this.loading = false;
        return;
      }

      this.newItem.id = result.data.id;
      this.loading = false;
      this.$emit('refresh');
      this.hideModal();
    },
    onJobPostingSelect(jobPostingId, jobPosting) {
      this.newItem.job_posting_id = jobPostingId;
      this.newItem.location_id = jobPosting ? jobPosting.location_id : null;
      this.newItem.location_name = jobPosting ? jobPosting.location_name : '';
    },
    onSelectCitizenship(citizenship) {
      if (citizenship) {
        this.$set(this.newItem, 'citizenship_id', citizenship.id);
      } else {
        this.$set(this.newItem, 'citizenship_id', null);
      }
    },
    onSelectTown(town) {
      if (town) {
        this.$set(this.newItem, 'town_id', town.id);
        this.$set(this.newItem, 'town_name', town.name);
      } else {
        this.$set(this.newItem, 'town_id', null);
        this.$set(this.newItem, 'town_name', '');
      }
    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    toggleFit() {
      this.newItem.fits = !this.newItem.fits
    },
    onSelectRecruitResponseStatus(status) {
      if (status) {
        this.$set(this.newItem, 'status_id', status.id);
        this.$set(this.newItem, 'status_name', status.name);
      } else {
        this.$set(this.newItem, 'status_id', null);
        this.$set(this.newItem, 'status_name', '');
      }
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Recruiting/JobPostingResponse.vue